import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DataService_DistrictLookup } from "./shared/data.service";
import { DistrictLookupRequest } from "./shared/DistrictLookupRequest";

@Component({
	selector: "app-district-lookup",
	templateUrl: "./district-lookup.component.html",
	styleUrls: ["./district-lookup.component.css"],
})
export class DistrictLookupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private DistrictLookupService: DataService_DistrictLookup,
		private dialogService: DialogService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadColumnOptions();

		this.loadMissingPhoto();

		this.loadPersonType();
		// this.loadPerson();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.SchoolID = school.SchoolID;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	// Cols to display
	lstColumnOptions: any = [];

	ImageDict: Map<number, string> = new Map(); //Dictionary that matches PersonPhotoData IDs to base64 of image
	lstImageCalls: any = [];

	// MissingPhotoData: any;

	subscription: any;
	SchoolSelectShowAll: any = false;
	SchoolID: any = -1;

	lstExtraOptions: any = [
		{
			SchoolID: -1,
			SchoolNumber: "-1",
			SchoolName: "All",
			SchoolFullName: "All",
		},
		{
			SchoolID: 0,
			SchoolNumber: "0",
			SchoolName: "District/No School Assigned",
			SchoolFullName: "District/No School Assigned",
		},
	];
	//List of items to add the beginning of the list (ex. ID: -2, Desc: Only Active Schools)
	//Example Entry:
	// {
	//   SchoolID: -2,
	//   SchoolNumber: "-2",
	//   SchoolName: "Only Active Schools",
	//   SchoolFullName: "Only Active Schools"
	// }

	Filter: any = "";

	LoadingPersonType: any = true;
	PersonTypeID: any = -1;
	lstPersonType: any = [];

	Active: any = -1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	lstPerson: any = [];

	//Filter lists
	lstSchoolName: any = [];
	lstPersonTypeDesc: any = [];
	lstIsStaffDesc: any = [];
	lstStaffTitle: any = [];
	lstActiveDesc: any = [];
	lstAttendanceStatusDesc: any = [];
	lstHasImageDesc: any = [];

	//Cols
	// cols: any = [
	//   //INSERT CUSTOM COLUMNS HERE
	//   { field: 'FirstName', header: 'First Name' },
	//   { field: 'LastName', header: 'Last Name' },
	//   { field: 'SchoolName', header: 'School' },
	//   { field: 'PersonTypeDesc', header: 'Person Type' },
	//   { field: 'IsStaffDesc', header: 'Staff' },
	//   { field: 'PersonID', header: 'Person ID' },
	//   { field: 'StudentID', header: 'Student ID' },
	//   { field: 'StaffID', header: 'Staff ID' },
	//   { field: 'StaffTitle', header: 'Staff Title' },
	//   { field: 'ActiveDesc', header: 'Active' },
	//   { field: 'AttendanceStatusDesc', header: 'Attendance Status' },
	//   { field: 'Barcodes', header: 'Barcodes' },
	//   { field: 'MTAID', header: 'MTAID' },
	//   { field: 'UID', header: 'UID' }
	// ];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadColumnOptions() {
		var result = this.DistrictLookupService.DistrictLookupGetColumns();
		result.subscribe(
			(response) => {
				this.lstColumnOptions = response;
			},
			(error) => {}
		);
	}

	loadMissingPhoto() {
		var result = this.DistrictLookupService.PersonGetPhotoByPhotoDataID(-1); //Missing Photo ID
		result.subscribe(
			(response) => {
				// this.MissingPhotoData = response[0].ImageData;

				this.ImageDict.set(-1, String(response[0].ImageData));
			},
			(error) => {}
		);
	}

	loadPersonType() {
		this.LoadingPersonType = true;

		var result = this.DistrictLookupService.PersonTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstPersonType = response;

				this.lstPersonType.unshift({
					PersonTypeID: -1,
					PersonTypeDesc: "Any Non-Staff",
				});

				this.lstPersonType.unshift({
					PersonTypeID: -2,
					PersonTypeDesc: "Any Staff",
				});

				this.lstPersonType.unshift({
					PersonTypeID: -3,
					PersonTypeDesc: "All",
				});

				this.PersonTypeID = this.lstPersonType[0].PersonTypeID;

				this.LoadingPersonType = false;
			},
			(error) => {
				this.LoadingPersonType = false;
			}
		);
	}

	loadPerson() {
		this.loading = true;

		let parms: DistrictLookupRequest = {
			Filter: this.Filter,
			PersonTypeID: this.PersonTypeID,
			Active: this.Active,
			SchoolID: this.SchoolID,
		};

		var result = this.DistrictLookupService.DistrictLookup(parms); //UserID from Controller
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolName))).sort();
				this.lstPersonTypeDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.PersonTypeDesc))).sort();
				this.lstIsStaffDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.IsStaffDesc))).sort();
				this.lstStaffTitle = Array.from(new Set(this.lstPerson.map((item: any) => item.StaffTitle))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
				this.lstAttendanceStatusDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.AttendanceStatusDesc))).sort();
				this.lstHasImageDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.HasImageDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	GetPhotoData(PersonPhotoDataID) {
		if (this.ImageDict.has(PersonPhotoDataID)) {
			return this.ImageDict.get(PersonPhotoDataID);
		} else {
			var found = false;

			for (var z = 0; z < this.lstImageCalls.length; z++) {
				var next = this.lstImageCalls[z];

				if (next == PersonPhotoDataID) {
					found = true;
					break;
				}
			}

			if (found) {
				return "assets\\images\\loading.gif";
				//return this.ImageDict.get(-1); //Already made the webservice call
			} else {
				//Make the webservice call 1 time
				this.lstImageCalls = [...this.lstImageCalls, PersonPhotoDataID]; //Add to list of calls made

				var result = this.DistrictLookupService.PersonGetPhotoByPhotoDataID(PersonPhotoDataID);
				result.subscribe(
					(response) => {
						this.ImageDict.set(PersonPhotoDataID, response[0].ImageData);

						return response[0].ImageData;
					},
					(error) => {
						return this.ImageDict.get(-1); //Missing Photo
					}
				);
			}
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSearch() {
		this.loadPerson();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		this.SelectedPerson = Person;
		// this.onEditPerson();
	}

	onPersonFilterKeyDown(event) {
		if (event.key == "Enter") {
			var SearchButton = document.getElementById("SearchButton");

			SearchButton.focus();
			SearchButton.click();
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.LoadingPersonType == true;
	}

	IsSelected(Field) {
		var ans = false;

		for (var z = 0; z < this.lstColumnOptions.length; z++) {
			var next = this.lstColumnOptions[z];

			if (next.Field == Field) {
				ans = next.Selected;
				break;
			}
		}

		return ans;
	}

	GetSelectedCols() {
		var ans = [];

		ans = this.lstColumnOptions.filter((col) => col.Selected == true && String(col.Field) != "Photo").sort((a, b) => a.ZOrder - b.ZOrder);

		return ans;
	}

	////////////////////////////////////////////
}
